import { useState, useEffect } from "react";

import { breakpoints } from "@scss/constants/mediaQuery";

const useDevice = () => {
  const { laptopS, mobileL, laptopL, desktopS } = breakpoints;

  const calcIsMobile = () => window.innerWidth <= mobileL;

  const calcIsTablet = () =>
    mobileL < window.innerWidth && window.innerWidth < laptopS;

  const calcIsLaptop = () =>
    laptopS <= window.innerWidth && window.innerWidth <= laptopL;

  const calcIsDesktop = () => desktopS <= window.innerWidth;

  const [isMobile, setIsMobile] = useState(calcIsMobile());
  const [isTablet, setIsTablet] = useState(calcIsTablet());
  const [isLaptop, setIsLaptop] = useState(calcIsLaptop());
  const [isDesktop, setIsDesktop] = useState(calcIsDesktop());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(calcIsMobile());
      setIsTablet(calcIsTablet());
      setIsLaptop(calcIsLaptop());
      setIsDesktop(calcIsDesktop());
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  return { isMobile, isTablet, isLaptop, isDesktop };
};

export default useDevice;
